export default __webpack_public_path__ + "static/media/hht2_ep14_timeline_q03_a.bc1de61f.png";